import {useEffect, useRef, useState} from 'react'

import PropTypes from 'prop-types'

import AtomTooltip, {AtomTooltipPlacements} from '@s-ui/react-atom-tooltip'
import {useOnClickOutside} from '@s-ui/react-hooks'

const SearchSaveTooltip = ({
  delay,
  content,
  children,
  hasZeroResults,
  showedZeroResultsTooltip,
  setIsViewedZeroResultsTooltip = () => {},
  showTooltip
}) => {
  const notificationRef = useRef()

  useOnClickOutside(notificationRef, () => {
    if (hasZeroResults) {
      setShowZeroResultsTooltip(false)
    }
  })

  const [showZeroResultsTooltip, setShowZeroResultsTooltip] = useState(!showedZeroResultsTooltip)

  const handleCloseTooltip = () => {
    if (hasZeroResults) {
      setIsViewedZeroResultsTooltip()
      setShowZeroResultsTooltip(false)
    }
  }

  useEffect(() => {
    if (delay) {
      const timer = setTimeout(() => handleCloseTooltip(), delay)
      return () => {
        clearTimeout(timer)
      }
    }
    if (hasZeroResults) {
      setShowZeroResultsTooltip(!showedZeroResultsTooltip)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasZeroResults])

  if (showTooltip) {
    return hasZeroResults ? (
      <AtomTooltip
        isVisible={showedZeroResultsTooltip && showZeroResultsTooltip}
        placement={AtomTooltipPlacements.AUTO}
        content={content}
        ref={notificationRef}
      >
        <div>{children}</div>
      </AtomTooltip>
    ) : (
      <div>{children}</div>
    )
  }
  return <div>{children}</div>
}

SearchSaveTooltip.propTypes = {
  delay: PropTypes.object,
  content: PropTypes.any,
  children: PropTypes.any,
  hasZeroResults: PropTypes.bool,
  showedZeroResultsTooltip: PropTypes.bool,
  setIsViewedZeroResultsTooltip: PropTypes.func,
  showTooltip: PropTypes.bool
}

export default SearchSaveTooltip
